import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OrderLineModel, OrderModel } from '@core/services/api.service';
import { GetOrderByIdAction } from '@ngxs-store/order-store/order.actions';
import { OrderState } from '@ngxs-store/order-store/order.state';
import { Select, Store } from '@ngxs/store';
import { Observable, Subject } from 'rxjs';

@Component({
  selector: 'app-orders-details-page',
  template: ` 
  <app-orders-details
  [order]="order$ | async"
  [isLoading]="isLoading$ | async">
  </app-orders-details> 
  
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrdersDetailsPageComponent implements OnInit {
  orderId: any;
  orderDetails$: Observable<OrderModel>;
  private readonly onDestroy = new Subject<void>();
  @Select(OrderState.getOrder) order$: Observable<OrderModel>;
  @Select(OrderState.isLoading) isLoading$: Observable<boolean>;
  constructor(
    private store: Store,
    private activatedRoute: ActivatedRoute  
    
   
  ) { }

  ngOnInit() { 
    this.activatedRoute.params.subscribe((params) => {
       this.store.dispatch(new GetOrderByIdAction({id: params.id}));
    });

  //      this.location.replace(
  //     this.activatedRoute.createUrlTree(
  //         null,
  //         {queryParams: null}
  //     ).toString()
  // );
  }




}